import React from 'react';

const SvgPlay = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    {...props}
  >
    <path
      d="M13.2627 6.70837L2.26274 0.205248C1.36899 -0.322877 0.000244141 0.189623 0.000244141 1.49587V14.499C0.000244141 15.6709 1.27212 16.3771 2.26274 15.7896L13.2627 9.28962C14.244 8.7115 14.2471 7.2865 13.2627 6.70837Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPlay;
